"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createFieldComponent = exports.FieldComponent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Input = _interopRequireDefault(require("./Input"));
var _excluded = ["meta", "id", "input", "children"];
var createFieldComponent = exports.createFieldComponent = function createFieldComponent(Component) {
  return function (field) {
    var _field$meta = field.meta,
      meta = _field$meta === void 0 ? {} : _field$meta,
      id = field.id,
      input = field.input,
      children = field.children,
      otherProps = (0, _objectWithoutProperties2["default"])(field, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      id: id
    }, otherProps, input, {
      error: meta.error,
      help: meta.touched && meta.error || otherProps.help,
      bsStyle: (meta.touched && meta.error ? 'error' : undefined) || otherProps.bsStyle
    }), children);
  };
};
var FieldComponent = exports.FieldComponent = createFieldComponent(_Input["default"]);
var _default = exports["default"] = FieldComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/ReduxFormFieldComponent.js
// module id = 1366
// module chunks = 25